/** @jsx jsx */
import { jsx, Styled, Container, Flex, Box } from "theme-ui";
import { graphql } from "gatsby";
import Img from "gatsby-image";

import Layout from "../components/layout";
import SEO from "../components/seo";
import QuestionAnswer from "../components/questionAnswer";

import PageIntro from "../components/pageIntro";
import CheckSquare from "../images/icons/checksquare.inline.svg";

const FAQS = ({ data: { faqs } }) => {
  return (
    <Layout>
      <SEO title={`FAQs | SecurEdge Team`} />
      <section>
        <Img
          fluid={faqs.hero.childImageSharp.fluid} />
        <PageIntro align="left">
          <Flex
            sx={{
              justifyContent: 'flex-start',
              flexWrap: 'wrap'
            }}>
            <Box
              sx={{
                px: 4
              }}>
              <div>
                <CheckSquare
                  sx={{
                    width: ['85px', '125px']
                  }} />
              </div>
            </Box>
            <Box
              sx={{
                px: 4
              }}>
              <Styled.h1
                sx={{
                  color: 'primary',
                  fontSize: [2, 6]
                }}>{ faqs.title }</Styled.h1>
              <p>{ faqs.subtitle }</p>
            </Box>
          </Flex>
        </PageIntro>
      </section>
      <section
        sx={{
          py: [3, 5]
        }}>
        <Container
          sx={{
            px: 4
          }}>
          <Flex
            sx={{
              mx: -4
            }}>
            <Flex
              sx={{
                px: 4,
                flexDirection: 'column'
              }}>
                {
                  faqs.question_answer.map(questionAnswer => (
                    <QuestionAnswer
                      key={questionAnswer.id} 
                      questionAnswer={questionAnswer} />
                  ))
                } 
              </Flex>
          </Flex>
        </Container>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    faqs: strapiFaq {
      title
      subtitle
      hero {
        childImageSharp {
          fluid(maxWidth: 1800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      question_answer {
        id
        question
        answer
      }
    }
  }
`

export default FAQS